import { useLocation, useNavigate } from "react-router-dom";
import { webPaths } from "../routes/pageRoutes";
import {
  SECURPOINT_APP_STORE_URL,
  SECURPOINT_PLAY_STORE_URL,
} from "../utils/mobileAppLinks";

const Footer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <>
      {/* DOWNLOAD APP SECTION */}
      <section class="download-app-section ct_py_80 pb-0 mt-5">
        <div class="container">
          <div class="download-box row align-items-center">
            {/* Mobile Image */}
            <div class="col-lg-5 text-center text-lg-start">
              <img
                src="/assets/img/mockup.png"
                class="phone-img"
                alt="App Mockup"
              />
            </div>

            {/* Content */}
            <div class="col-lg-7">
              <div class="py-5">
                <h3 class="ct_fs_32 ct_switzer_Medium text-white">
                  Download the SecurPoint App
                </h3>
                <p
                  class="ct_fs_18 ct_switzer_light text-white ct_mb_30"
                  style={{ maxWidth: "557px" }}
                >
                  Download the app to unlock all features, manage your assets
                  securely, and stay in full control wherever you are.
                </p>

                {/* Buttons */}
                <div class="d-flex gap-4 ct_flex_col_575 ct_mt_30">
                  <a
                    href={SECURPOINT_APP_STORE_URL}
                    target="_blank"
                    class="store-btn justify-content-center ct_w_100_575"
                    rel="noreferrer"
                  >
                    <img src="/assets/img/apple_icon.png" alt="" /> App Store
                  </a>
                  <a
                    href={SECURPOINT_PLAY_STORE_URL}
                    target="_blank"
                    class="store-btn justify-content-center ct_w_100_575"
                    rel="noreferrer"
                  >
                    <img src="/assets/img/play_stor_clr.png" alt="" /> Google
                    Play
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer class="footer-section">
        <div class="container">
          <div class="row justify-content-between">
            {/* Left */}
            <div class="col-md-6 mb-4 mb-md-0">
              <a
                href=""
                class="footer-logo d-flex align-items-center gap-2 mb-3"
              >
                <img src="/assets/img/logo_white.png" alt="" />
              </a>

              <p class="footer-text">
                SecurPoint is a premium asset management platform designed to
                help you track, manage, and secure your valuable assets with
                enterprise-grade security and intuitive user experience.
              </p>

              {/* Social Icons */}
              <div class="social-icons d-flex gap-4 mt-4">
                <a href="#">
                  <i class="fa-brands fa-instagram"></i>
                </a>
                <a href="#">
                  <i class="fa-brands fa-facebook-f"></i>
                </a>
                <a href="#">
                  <i class="fa-brands fa-twitter"></i>
                </a>
                <a href="#">
                  <i class="fa-brands fa-linkedin-in"></i>
                </a>
              </div>
            </div>

            {/* Right Links */}
            <div class="col-md-3 mb-4 mb-md-0">
              <ul class="footer-links">
                <li>
                  <a
                    className={pathname == webPaths?.Faq ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(webPaths?.Faq);
                    }}
                  >
                    FAQ
                  </a>
                </li>
                <li>
                  <a
                    className={
                      pathname == webPaths?.TermsofService ? "active" : ""
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(webPaths?.TermsofService);
                    }}
                  >
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    className={
                      pathname == webPaths?.PrivacyPolicy ? "active" : ""
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(webPaths?.PrivacyPolicy);
                    }}
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    className={
                      pathname == webPaths?.HelpSupport ? "active" : ""
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(webPaths?.HelpSupport);
                    }}
                  >
                    Help & Support
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Line */}
          <hr class="footer-line" />

          <p class="text-center text-white small mb-0 opacity-75 ct_switzer_extra_light">
            © 2026 SecurPoint
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
